import { styled } from "@mui/material";
import Select from "../select/Select";
import clsx from "clsx";
import { useIndexTypes } from "stores";

const SelectStyled = styled(Select)({
  "& .select": {
    backgroundColor: "#FFFFFFAA",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: "#FFFFFF",
    },
    "&.loading": {
      minWidth: "150px",
    },
    "&.disabled": {
      "&:hover": {
        backgroundColor: "#FFFFFFAA",
      },
    },
  },
});

const SelectIndexType = ({
  isIndicesLoading,
  isDisabled,
  indicesError,
  onSelect,
  value,
}) => {
  const { indexTypes } = useIndexTypes();

  const shouldBeDisabled = isDisabled || isIndicesLoading || indicesError;
  return (
    <SelectStyled
      isLoading={isIndicesLoading}
      isDisabled={shouldBeDisabled}
      options={indexTypes}
      value={value}
      className={clsx({
        loading: isIndicesLoading,
        disabled: shouldBeDisabled,
      })}
      onChange={(e) => {
        onSelect?.(e.target.value);
      }}
    />
  );
};

export default SelectIndexType;
